import { styled } from '@mui/material'

export const GroupWrapper = styled('div')({
  width: '50%',
  overflow: 'hidden',
})
